import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';

const element = document.getElementById('slider')

if (element) {
  new Splide(element, {
    arrows: false,
    autoplay: true,
    classes: {
      pagination: 'slider__pagination',
      page: 'slider__page',
    },
    pagination: true,
    type: 'loop',
  }).mount();
}